/** axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
// import service from 'axios'
import axios from 'axios'
import {
  MessageBox
  //  Message
} from 'element-ui'
import QS from 'qs'
// import { Toast } from 'vant'
import router from '@/router'
import store from '@/store'
let serviceConfig = '/api/v1/'

// const axios = service.create({
//   baseURL: serviceConfig // api的base_url
//   /* baseURL: "http://192.168.0.107:9090", */ // api的base_url
// })
// 环境的切换
if (process.env.NODE_ENV === 'development') {
  axios.defaults.baseURL = serviceConfig // 'api'
  //   axios.defaults.baseURL = 'api'
} else if (process.env.NODE_ENV === 'debug') {
  axios.defaults.baseURL = ''
} else if (process.env.NODE_ENV === 'production') {
  axios.defaults.baseURL = serviceConfig
  //   axios.defaults.baseURL = '/api'
}

// 请求超时时间
axios.defaults.timeout = 5000

// post请求头
axios.defaults.headers.post['Content-Type'] =
  // 'application/x-www-form-urlencoded;charset=UTF-8'
  'application/json'
// 请求拦截器
axios.interceptors.request.use(
  config => {
    // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
    // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
    config.withCredentials = true
    const token = sessionStorage.getItem('token')
    token && (config.headers.Authorization = token)
    return config
  },
  error => {
    return Promise.error(error)
  }
)

// 响应拦截器
axios.interceptors.response.use(
  response => {
    console.log(response,"response")
    if (response.status === 200) {
      if (response.data.code === '0000' || !response.data.code || response.data.message == '用户名或密码错误') {
        return Promise.resolve(response)
      } else if (response.data.code === 'U0004') {
        MessageBox.alert(response.data.message || '请重新登录！', '提示', {
          confirmButtonText: '确定'
        }).then(() => {
          // 清除token
          sessionStorage.removeItem('token')
          store.commit('SET_USERLOGINEDINFO', null)
          // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
          router.replace({
            path: '/login',
            query: {
              redirect: router.currentRoute.fullPath
            }
          })
        })
      } else {
        console.log(response, 'response')
        MessageBox.alert(response.data.message || '请求失败，请联系管理员。', '提示', {
          confirmButtonText: '确定'
        })
      }
    } else {
      return Promise.reject(response)
    }
  },
  // 服务器状态码不是200的情况
  error => {
    if (error.response.status) {
      switch (error.response.status) {
        // 401: 未登录
        // 未登录则跳转登录页面，并携带当前页面的路径
        // 在登录成功后返回当前页面，这一步需要在登录页操作。
        case 401:
          router.replace({
            path: '/login',
            query: { redirect: router.currentRoute.fullPath }
          })
          break
        // 403 token过期
        // 登录过期对用户进行提示
        // 清除本地token和清空vuex中token对象
        // 跳转登录页面
        case 403:
          MessageBox.alert('登录超时，请重新登录！', '提示', {
            confirmButtonText: '确定'
          }).then(() => {
            // 清除token
            localStorage.removeItem('token')
            store.commit('loginSuccess', null)
            // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
            router.replace({
              path: '/login',
              query: {
                redirect: router.currentRoute.fullPath
              }
            })
          })

          break
        // 404请求不存在
        case 404:
          MessageBox.alert('网络请求不存在', '提示', {
            confirmButtonText: '确定'
          })
          break
        // 其他错误，直接抛出错误提示
        default:
          MessageBox.alert(error.response.data.message || '请求失败！', '提示', {
            confirmButtonText: '确定'
          })
      }
      return Promise.reject(error.response)
    }
  }
)
/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export const get = (url, params) => {
  console.log(params, 'params')
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params
      }
      )
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data)
      })
  })
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export const post = (url, ...params) => {
  return new Promise((resolve, reject) => {
    axios // QS.stringify(params)关于这个函数会输出什么结果大家可以自行尝试一下，结果会让你惊喜，也可以自己单独传一个对象进去测试一下
      .post(url, ...params)
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data)
      })
  })
}
/**
 * delet方法，对应delett请求
 * @param {String} url [请求的url地址]
 * delete关键字会和vue系统关键字冲突，所以这里用delet代替
 * delete用于删除，参数一般带在url
 */
export const delet = url => {
  return new Promise((resolve, reject) => {
    axios
      .delete(url)
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data)
      })
  })
}
/**
 * patch方法，对应patch请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * 这里根据需求适应了formdata的格式，也可以跟post用一样的封装
 */
export const patch = (url, params) => {
  // 将数据转换为formData格式
  // 正常情况下可以直接使用参数对象进行patch，如果出错可以尝试转换form Data
  var formData = new FormData()
  formData.append('username', params.username)
  formData.append('password', params.password)
  return new Promise((resolve, reject) => {
    axios
      .patch(url, formData)
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data)
      })
  })
}



// WEBPACK FOOTER //
// ./src/api/http/index.js